import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AuthSubscriptionService } from '../services/auth-subscription.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authSubscriptionService: AuthSubscriptionService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    const tokenValidHeader = event.headers.get('X-Token-Valid');

                    if (!tokenValidHeader) {
                        return;
                    }

                    if (tokenValidHeader === 'true') {
                        this.authSubscriptionService.sendAuthStateChangeNotification(true);
                    }
                }
            })
        );
    }
}
